export function OpencvIcon({ className }: { className?: string }) {
    return (
      <svg 
        className={className} 
        width="61" 
        height="56" 
        viewBox="0 0 61 56" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path 
          d="M22.8259 26.2937C17.3028 23.1049 14.6101 16.604 16.2607 10.4438C17.9113 4.28355 23.4938 0 29.8713 0C36.2489 0 41.8313 4.28355 43.482 10.4438C45.1326 16.604 42.4398 23.1049 36.9167 26.2937L32.6742 18.9455C34.8715 17.6769 35.9427 15.0906 35.286 12.6399C34.6294 10.1892 32.4085 8.48504 29.8713 8.48504C27.3341 8.48504 25.1133 10.1892 24.4566 12.6399C23.7999 15.0906 24.8712 17.6769 27.0685 18.9455L22.8259 26.2937Z" 
          fill="#FF0101" 
        />
        <path 
          d="M53.0002 29.7048C58.5234 32.8936 61.2161 39.3945 59.5655 45.5547C57.9148 51.715 52.3324 55.9985 45.9548 55.9985C39.5773 55.9985 33.9949 51.715 32.3442 45.5547C30.6936 39.3945 33.3863 32.8936 38.9095 29.7048L43.152 37.0531C40.9547 38.3217 39.8835 40.9079 40.5401 43.3586C41.1968 45.8094 43.4177 47.5135 45.9548 47.5135C48.492 47.5135 50.7129 45.8094 51.3696 43.3586C52.0262 40.9079 50.955 38.3217 48.7577 37.0531L53.0002 29.7048Z" 
          fill="#0101FF" 
        />
        <path 
          d="M28.1818 41.908C28.1818 48.2855 23.8983 53.868 17.738 55.5186C11.5778 57.1692 5.07691 54.4765 1.88813 48.9534C-1.30065 43.4302 -0.382197 36.4539 4.12742 31.9443C8.63703 27.4347 15.6133 26.5162 21.1365 29.705L16.8939 37.0533C14.6967 35.7847 11.9213 36.1501 10.1272 37.9441C8.33319 39.7382 7.9678 42.5136 9.23639 44.7108C10.505 46.9081 13.0912 47.9794 15.542 47.3227C17.9927 46.666 19.6968 44.4452 19.6968 41.908H28.1818Z" 
          fill="#01FF01" 
        />
      </svg>
    )
  }